module.exports = __webpack_public_path__ + "static/media/text.b2b855e4.svg";